import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateBlockDirective } from '@ngx-translate/core';
import { InputToggleInterface } from '../../../types/interfaces/input.interface';

@Component({
  selector: 'app-toggle-switch',
  standalone: true,
  imports: [
    FormsModule,
    TranslateBlockDirective,
  ],
  templateUrl: './button-toggle.html',
  styleUrl: './button-toggle.css',
})
export class ToggleSwitchComponent {
  @Input()
  public formData!: InputToggleInterface;

  @Input()
  public isLoading: boolean = false;

  @Output()
  public checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public get checked(): boolean {
    return this.formData.formGroup?.get(this.formData.id)?.value ?? false;
  }

  public onToggle(event: Event): void {
    if (this.formData.readonly) {
      event.preventDefault();
      return
    }

    const input = event.target as HTMLInputElement;
    const value: boolean = input?.checked;

    this.formData.formGroup?.get(this.formData.id)
      ?.setValue(value);
    this.checkedChange.emit(value);

    if (this.formData.onChange) {
      this.formData.onChange(value);
    }
  }
}
